var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9487 6.95159L17.5487 10.5516M4.94873 19.5516L9.31472 18.6719C9.54649 18.6252 9.75931 18.511 9.92645 18.3438L19.7001 8.56477C20.1687 8.09591 20.1684 7.33592 19.6994 6.86746L17.629 4.79939C17.1602 4.33112 16.4006 4.33144 15.9322 4.8001L6.15749 14.5802C5.99068 14.7471 5.87678 14.9594 5.83003 15.1907L4.94873 19.5516Z",
    stroke: "#F9009E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.2e2e2a15dabe2cc42413666c9fa32334.svg";
export { ForwardRef as ReactComponent };